import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import useLoading from '../useLoading';
import useAlerts from '../useAlerts';

import {
  setDebitFilteredDocuments,
  setDebitProductOptions,
  clearDebitFilteredDocuments,
  clearDebitProductOptions,
} from '../../store/slices/purchases/debitNoteLookupSlice';

import DebitNoteLookupService from '../../services/purchases/DebitNoteLookupService';
import { CreditNoteLookupFilter } from '../../types/purchases/CreditNoteLookup'; // Reutilizado para filtros

export const useDebitNoteLookup = () => {
  const dispatch = useDispatch();
  const { show: showAlert } = useAlerts();
  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  const { filteredDocuments, productOptions } = useSelector(
    (state: RootState) => state.debitNoteLookup
  );

  const searchEligiblePurchases = async (filters: CreditNoteLookupFilter) => {
    try {
      showLoadingIndicator();
      const response = await DebitNoteLookupService.searchEligiblePurchases(filters);

      if (response.statusCode === 200) {
        dispatch(setDebitFilteredDocuments(response.data));
      } else {
        showAlert('error', 'Error', 'No se pudieron obtener los documentos.');
      }
    } catch (error) {
      console.error('❌ Error al buscar documentos para nota de débito:', error);
      showAlert('error', 'Error', 'Ocurrió un error inesperado.');
    } finally {
      hideLoadingIndicator();
    }
  };

  const fetchProductsByPurchase = async (purchaseId: number) => {
    try {
      showLoadingIndicator();
      const response = await DebitNoteLookupService.getProductsByPurchase(purchaseId);
      if (response.statusCode === 200) {
        dispatch(setDebitProductOptions(response.data));
      } else {
        showAlert('error', 'Error', 'No se pudieron obtener los productos.');
      }
    } catch (error) {
      console.error('❌ Error al obtener productos:', error);
      showAlert('error', 'Error', 'Ocurrió un error inesperado.');
    } finally {
      hideLoadingIndicator();
    }
  };

  const clearDebitNoteLookup = () => {
    dispatch(clearDebitFilteredDocuments());
    dispatch(clearDebitProductOptions());
  };

  return {
    filteredDocuments,
    productOptions,
    searchEligiblePurchases,
    fetchProductsByPurchase,
    clearDebitNoteLookup,
  };
};
